class CookieHelper {
    getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            // eslint-disable-next-line
            `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    }

    deleteCookie(name) {
        this.setCookie(name, '', {
            'max-age': -1,
        })
    }

    setCookie(name, value, optionsAttr = {}) {
        const options = {
            path: '/',
            ...optionsAttr,
        }

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString()
        }

        let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

        for (const optionKey in options) {
            updatedCookie += `; ${optionKey}`
            const optionValue = options[optionKey]
            if (optionValue !== true) {
                updatedCookie += `=${optionValue}`
            }
        }

        document.cookie = updatedCookie
    }
}

export default CookieHelper
